import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import BackButton from '../../custom/BackButton';
import ActionIcon from '../../custom/ActionIcon';
import { createdUpdatedInfo, formatDatetime } from '../../../utils';
import { ChangeEvent, IReadingSign } from '../../../globals/interfaces';
import { Input } from 'reactstrap';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    readingSign: IReadingSign;
    readingSignAudit: (auditedNotes: string) => Promise<void>;
}

export default function ModalAudit({
    modal,
    setModal,
    readingSign,
    readingSignAudit
}: Props) {

    const toggle = () => setModal(!modal);
    const [auditedNotes, setAuditedNotes] = useState('');

    useEffect(() => {
        setAuditedNotes(readingSign.auditedNotes);
    }, [readingSign]);

    return (
        <Modal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Audit Notes</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <Input 
                    value={auditedNotes}
                    onChange={(e: ChangeEvent) => setAuditedNotes(e.target.value)}
                    type={'textarea'}
                    style={{
                        height: '200px'
                    }}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    {
                        readingSign.auditedBy ? (
                            <Label>
                                Last modified by {readingSign.auditedBy} at {formatDatetime(readingSign.auditedDate)}
                            </Label>
                        ) : (
                            <Label>Not previously audited</Label>
                        )
                    }
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={() => readingSignAudit(auditedNotes)} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;